import React, { useEffect } from "react";
import { EditIcon } from "@bale/ui";
import { getFileSizeString, getFileTypeString } from "utils/utils";
import styles from "./ImageInputPreview.module.scss";
import { useTheme } from "@emotion/react";
import { strings } from "intl/fa";

interface Props {
  file: File;
  onEdit?: () => void;
  label?: string;
}

const ImageInputPreview: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const theme = useTheme();
  const isPDF = props.file.type === "application/pdf";
  let imagePreview = URL.createObjectURL(props.file);
  if (isPDF) {
    imagePreview = "/icons/PDFfile.svg";
  }

  useEffect(() => {
    return () => {
      URL.revokeObjectURL(imagePreview);
    };
  });

  return (
    <div className={styles.Container}>
      <div className={styles.Label}>
        {props.label ?? strings.common.input.image.label}
      </div>
      <div className={styles.EditIconContainer}>
        <div className={styles.EditIconWrapper} onClick={props.onEdit}>
          <EditIcon size={16} color={theme.colors.light.on_primary} />
        </div>
      </div>
      <div className={styles.FileInfo}>
        <span className={styles.FileName}>{props.file.name}</span>
        <span className={styles.FileSize}>
          {getFileSizeString(props.file.size)}{" "}
          {getFileTypeString(props.file.type)}
        </span>
      </div>
      {isPDF ? (
        <img
          className={styles.PDFPreview}
          src={"/icons/PDFfile.svg"}
          alt="file"
        />
      ) : (
        <img className={styles.Img} src={imagePreview} alt="file" />
      )}
    </div>
  );
};

export default ImageInputPreview;
